import { useQueryClient } from '@tanstack/react-query';

import type { Whitelabel } from '@/types/api/user';

import SmallSpinner from '@/components/shared/spinners/small-spinner';
import '@/components/shared/spinners/large-spinner.css';

/**
 * Spinner de démarrage, avec le logo de la marque blanche s'il est déjà connu.
 *
 * Le logo n'est lu que dans le cache : ce spinner s'affiche justement pendant les premiers
 * chargements, il ne doit pas en déclencher.
 */
const LargeSpinner = () => {
    const queryClient = useQueryClient();
    const whitelabel = queryClient.getQueriesData<Whitelabel>({ queryKey: ['whitelabel'] }).find(([, data]) => data)?.[1];
    const logo = whitelabel?.logo_light_url;

    return (
        <div id={'start-loader'} className={'mx-auto my-12'}>
            {logo && <img src={logo} alt="Logo" width={300} />}
            <SmallSpinner />
        </div>
    );
};

export default LargeSpinner;
